import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-documentos-subasta',
  templateUrl: './documentos-subasta.component.html',
  styleUrls: ['./documentos-subasta.component.scss']
})
export class DocumentosSubastaComponent {

  constructor(private loginService:LoginService) { }

  clickGuard(){
    this.loginService.clickGuard = true;
 }
}
